/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useEffect, useState} from 'react'
import {bucketUrl, isNotEmpty} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/UsersListViewProvider'
import {Medium} from '../../core/_models'

type Props = {
  medium: Medium
}

// Iniciais: primeira letra do primeiro nome + primeira letra do último sobrenome
const getInitials = (nome: string): string => {
  const parts = nome.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
}

const MediumInfoCell: FC<Props> = ({medium}) => {
  const {setItemIdForUpdate} = useListView()
  // Se a URL da foto existir mas estiver quebrada/indisponível, cai para as iniciais
  const [fotoError, setFotoError] = useState(false)

  // A tabela reutiliza as instâncias de célula por posição ao trocar de página
  // (a chave da linha é o índice). Sem este reset, o erro de foto de um registro
  // "vazaria" para o registro que ocupar a mesma posição em outra página.
  useEffect(() => {
    setFotoError(false)
  }, [medium.id_medium, medium.foto])

  const openEditModal = () => {
    setItemIdForUpdate(medium.id_medium)
  }

  const showFoto = isNotEmpty(medium.foto) && !fotoError

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
        <a href='#'>
          {showFoto ? (
            <div className='symbol-label'>
              <img
                src={bucketUrl(`${medium.foto}`)}
                alt={medium.nome_medium?.charAt(0)}
                className='w-100'
                onError={() => setFotoError(true)}
              />
            </div>
          ) : (
            <div className={clsx('symbol-label fs-3', 'bg-light-primary', 'text-primary')}>
              {getInitials(medium.nome_medium || '')}
            </div>
          )}
        </a>
      </div>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1' onClick={openEditModal}>
          {medium.nome_medium}
        </a>

        {medium.nome_emite ? <span>Nome emissão: {medium.nome_emite}</span> : <></>}
      </div>
    </div>
  )
}

export {MediumInfoCell}
